import * as Yup from 'yup';

const errorMessage = "L'acteur doit être associé à au moins une catégorie";

export const DetailsSchema = Yup.object().shape({
  categoryIds: Yup.array()
    .of(Yup.string().required(errorMessage))
    .required(errorMessage)
    .min(1, errorMessage),
});
